import React from 'react';
import { motion } from 'framer-motion';
import './JaapaCounter.css';

// Now accepts label, count, and a boolean for styling
const JaapaCounter = ({ label, count, isMalaCounter = false }) => {
  return (
    <div className={`jaapa-counter ${isMalaCounter ? 'mala-counter' : ''}`}>
      <h3 className="counter-label">{label}</h3>
      <motion.div
        key={count}
        className="counter-value"
        initial={{ opacity: 0, y: -15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      >
        {count}
      </motion.div>
    </div>
  );
};

export default JaapaCounter;